// extracted by mini-css-extract-plugin
export default {"metaContainer":"MetaField_metaContainer__93CFU","field":"MetaField_field__sUQso"};